import { render, staticRenderFns } from "./WalletWatchlist.vue?vue&type=template&id=5cb6e716&scoped=true&"
import script from "./WalletWatchlist.vue?vue&type=script&lang=js&"
export * from "./WalletWatchlist.vue?vue&type=script&lang=js&"
import style0 from "./WalletWatchlist.vue?vue&type=style&index=0&id=5cb6e716&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb6e716",
  null
  
)

export default component.exports